import { postrootpath } from "./apirootpath";
const baseURL = postrootpath
async function PostUserproject(post_data){
    try {
      const res = await fetch(`${baseURL}/commitusrpoly`, {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(post_data),
      })
      
      if (!res.ok) {
        const message = `An error has occured: ${res.status} - ${res.statusText}`;
        throw new Error(message);
      }
      if(res.ok){
      const data = await res.json();
      alert(data.message)
      }
     
    } catch (err) {
      alert(err.message)
    }
  }

export default PostUserproject